import * as React from 'react';
import classNames from 'clsx';
import MenuButtonLink from '../../MenuButtonLink';
import MenuButtonBackground from '../../MenuButtonBackground';
import MenuButtonRoot from '../../MenuButtonRoot';
import type { MenuButtonProps } from '../../../MenuButton.types';
import skinsStyle from './styles/skins.scss';

const IndentedMenuButtonNSkin: React.FC<MenuButtonProps> = props => {
  const {
    id,
    'aria-haspopup': ariaHasPopup,
    'aria-describedby': ariaDescribedBy,
    'aria-current': ariaCurrent,
    'aria-expanded': ariaExpanded,
    role,
    isMoreButton,
    dir,
    textAlign,
    positionInList,
    link,
  } = props;

  return (
    <MenuButtonRoot
      {...props}
      compClassName={classNames(
        props.compClassName,
        skinsStyle.IndentedMenuButtonNSkin,
      )}
    >
      {label => (
        <MenuButtonLink
          wrapperProps={{
            positionInList,
            ariaHasPopup,
            ariaDescribedBy,
            isMoreButton,
            ariaCurrent,
            ariaExpanded,
            role,
          }}
          link={link}
          className={skinsStyle.linkElement}
        >
          <div className={skinsStyle.extra}>
            <div className={skinsStyle.wrapper}></div>
          </div>
          <MenuButtonBackground
            wrapperProps={{ dir, textAlign, id }}
            classNames={{ bg: skinsStyle.bg, label: skinsStyle.label }}
          >
            {label}
          </MenuButtonBackground>
        </MenuButtonLink>
      )}
    </MenuButtonRoot>
  );
};

export default IndentedMenuButtonNSkin;
